import React from 'react'

export default function MainTitle() {
    return (
        <div className="max-w-2xl lg:mt-0 md:mt-0 lg:mx-0">
            <h2 className="text-3xl sm:text-5xl font-normal tracking-tight text-TEXT_GREY ">
                Feel Better about
            </h2>
            <h2 className="text-3xl sm:text-5xl font-normal tracking-tight text-TEXT_GREY ">
                Finding <span className="text-BLUE font-semibold">Healthcare</span>
            </h2>
            <p className="my-8 text-base sm:text-lg leading-7 text-TEXT_GREY">
                Healththy 24 Online ranks highest in telehealth satisfaction among direct-to-consumer brands.
            </p>
        </div>
    )
}
